import { render, staticRenderFns } from "./TutorialsReminder.vue?vue&type=template&id=f3878c04&scoped=true&"
import script from "./TutorialsReminder.vue?vue&type=script&lang=js&"
export * from "./TutorialsReminder.vue?vue&type=script&lang=js&"
import style0 from "./TutorialsReminder.vue?vue&type=style&index=0&id=f3878c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3878c04",
  null
  
)

export default component.exports